/**
 * @desc 进度查询
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 流程平台实例ID */
  instanceId: string;
  /** 任务类型：1：年度，2：季度，3：月度，4：周 */
  taskType?: number;
  /** 类型:0：生产计划评审，1：报警处理，2：事件处理，3：库容审批 */
  titleType: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryPersonalTaskProgressResponse>> {
  return defHttp.get({
    url: '/web/personal/progress',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryPersonalTaskProgressResponse>> {
  return defHttp.get({
    url: '/mock/web/personal/progress',

    params,
  });
}
